import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientButton"] */ "/app/src/components/Button/Button.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Card/CardSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IconLottie"] */ "/app/src/components/Icon/IconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tab"] */ "/app/src/components/Tab/Tab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabLifted"] */ "/app/src/components/Tab/TabLifted.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/UpAnimations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccelerateAndBuildSection"] */ "/app/src/sections/develocity/AccelerateAndBuildSection/AccelerateAndBuildSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CiIntegrationSection"] */ "/app/src/sections/develocity/CiIntegrationSection/CiIntegrationSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/develocity/HeroMainSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpactCounterSection"] */ "/app/src/sections/develocity/ImpactCounterSection/ImpactCounterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProactiveReactiveSection"] */ "/app/src/sections/develocity/ProactiveReactiveSection/ProactiveReactiveSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProactiveReactiveSectionMobile"] */ "/app/src/sections/develocity/ProactiveReactiveSection/ProactiveReactiveSectionMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDemoSection"] */ "/app/src/sections/develocity/ProductDemoSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReleaseVersionSection"] */ "/app/src/sections/develocity/ReleaseVersionSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReportingSection"] */ "/app/src/sections/develocity/ReportingSection/ReportingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoSection"] */ "/app/src/sections/develocity/VideoSection/VideoSection.tsx");
